import React, { useContext } from 'react';
import { Optional } from '@honda-canada/design-system-react';

import HeaderContext from '../service/HeaderContext';
import Language from '../Menu/Language';
import Secondary from '../Menu/Secondary';

const SecondaryNav = () => {
  const { showLanguageMenu } = useContext(HeaderContext);

  return (
    <>
      <Secondary />
      <Optional when={showLanguageMenu}>
        <Language />
      </Optional>
    </>
  );
};

export default SecondaryNav;
